import cn from 'classnames'

import { NoteIcon, ActionIcon } from 'src/shared/icons'
import { Typography } from 'src/shared/ui/Typography'

import styles from './index.module.css'

type Props = {
  className?: string
  clickable?: boolean
  onClick?: () => void
}

export const Logotype = ({ className, clickable = false, onClick }: Props) => {
  const wrapperProps = {
    className: cn(styles.component, className, { [styles.clickable]: clickable }),
    ...(clickable && {
      role: 'button',
      tabIndex: 0,
      onClick,
    }),
  }

  return (
    <div {...wrapperProps}>
      <NoteIcon />
      <div className={styles.inner}>
        <ActionIcon />
        <Typography view="semibold_16">Сервис согласий</Typography>
      </div>
    </div>
  )
}
